export default __webpack_public_path__ + "static/media/technologie magie.91cb0f33.png";